<template>
  <div>
    <on-screen/>
    <!--<ontime-timer :url="ontimeUrl"/>-->
  </div>
</template>

<script>
import OnScreen from '../screen/OnScreen.vue'
import OntimeTimer from '../ontime/OntimeTimer.vue'
export default {
  name: 'ScreenPage',
  components: {
    OnScreen,
    OntimeTimer
  },
  computed: {
    ontimeUrl () {
      return this.$store.getters['settings/ontimeUrl']
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/ScreenPage.vue